import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './Card.scss';

const Card = ({ children, className = '' }) => (
    <div className={getClassName(styles.card, className)}>{children}</div>
);

export default Card;
